import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
// F-13: logout은 의도적으로 직접 axios 사용 (토큰 만료 시 refresh 불필요)

// 세션 타임아웃 설정 (12시간)
const SESSION_TIMEOUT = 12 * 60 * 60 * 1000; // 12시간

// 로컬 스토리지에서 사용자 정보 가져오기 (타임아웃 체크)
const getUserInfoFromStorage = () => {
  const userInfo = localStorage.getItem('userInfo');
  const loginTime = localStorage.getItem('loginTime');

  if (userInfo && loginTime) {
    const elapsed = Date.now() - parseInt(loginTime);
    if (elapsed < SESSION_TIMEOUT) {
      return JSON.parse(userInfo);
    } else {
      // 타임아웃 - 로그아웃
      localStorage.removeItem('userInfo');
      localStorage.removeItem('loginTime');
      return null;
    }
  }
  return null;
};

const userInfoFromStorage = getUserInfoFromStorage();

// 초기 상태
const initialState = {
  userInfo: userInfoFromStorage,
  loading: false,
  error: null,
};

// 로그인 액션
export const login = createAsyncThunk(
  'auth/login',
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        '/api/users/login',
        { username, password },
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        }
      );

      // 서버 응답 그대로 저장 (토큰 포함 시 하위 호환)
      localStorage.setItem('userInfo', JSON.stringify(data));
      localStorage.setItem('loginTime', Date.now().toString());

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      );
    }
  }
);

// 로그아웃 액션 (서버 측 refresh token 무효화)
export const logout = createAsyncThunk('auth/logout', async () => {
  try {
    const raw = localStorage.getItem('userInfo');
    if (raw) {
      const parsed = JSON.parse(raw);
      const headers = parsed?.accessToken
        ? { Authorization: `Bearer ${parsed.accessToken}` }
        : {};
      await axios.post(
        '/api/users/logout',
        { refreshToken: parsed?.refreshToken },
        { headers, withCredentials: true, timeout: 5000 }
      ).catch(() => {}); // 서버 호출 실패해도 클라이언트 로그아웃 진행
    }
  } catch (_) {}
  localStorage.removeItem('userInfo');
  localStorage.removeItem('loginTime');
  return null;
});

// 인증 슬라이스
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    // F-11: 토큰 갱신 시 Redux 동기화
    updateTokens: (state, action) => {
      if (state.userInfo) {
        state.userInfo = { ...state.userInfo, ...action.payload };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // 로그인
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfo = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 로그아웃
      .addCase(logout.fulfilled, (state) => {
        state.userInfo = null;
      });
  },
});

export const { clearError, updateTokens } = authSlice.actions;

export default authSlice.reducer;
